import { render, staticRenderFns } from "./RiskReport.vue?vue&type=template&id=09c0aaf2&scoped=true&"
import script from "./RiskReport.vue?vue&type=script&lang=js&"
export * from "./RiskReport.vue?vue&type=script&lang=js&"
import style0 from "./RiskReport.vue?vue&type=style&index=0&id=09c0aaf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c0aaf2",
  null
  
)

export default component.exports